import { render, staticRenderFns } from "./SalesPerformance.vue?vue&type=template&id=64448e56&scoped=true"
import script from "./SalesPerformance.vue?vue&type=script&lang=js"
export * from "./SalesPerformance.vue?vue&type=script&lang=js"
import style0 from "./SalesPerformance.vue?vue&type=style&index=0&id=64448e56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64448e56",
  null
  
)

export default component.exports